export default "__VITE_ASSET__BKu51NEb__"